module.exports = __webpack_public_path__ + "img/Web-Nord-Charl-van-Rooy-178903.jpg";